import { Badge, Col, Dropdown, Modal, Row, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { color } from "../../../resource";
import Input from "../../../components/Input/Input";
import Select from "../../../components/Select/Select";
import { CardContainer } from "../../../components/Card/CardContainer";

import Text from "../../../components/Text/Text";
import Button from "../../../components/Button/Button";
import { dateFormatter } from "../../../utility/Formatter";
import { teamDatasource } from "../../../datasource/TeamDatasource";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../../store/RoleAtom";
import { checkPermission } from "../../../components/Permission/Permission";
import icon from "../../../resource/icon";
import { payloadTeam, teamEntity } from "../../../entities/TeamEntity";
const Header = styled(Col)`
  border-radius: 8px;
  background-color: ${color.background1};
  padding: 20px;
  //display: flex;
  //gap: 16px;
  align-items: center;
  width: "100%";
`;

export const TeamSettingPage: React.FC = () => {
  const navigate = useNavigate();

  const roleData = useRecoilValue(roleAtom);
  const isCreate = checkPermission(["zoneSetting", "create"], roleData);
  const isEdit = checkPermission(["zoneSetting", "edit"], roleData);
  const [teamList, setTeamList] = useState<{ count: number; data: teamEntity[] }>({
    count: 0,
    data: [],
  });

  const pageSize = 10;
  const [page, setPage] = useState<number>(1);
  const [search, setSearch] = useState<string>("");
  const [status, setStatus] = useState<string | null | undefined>();
  // const [zoneList, setZoneList] = useState<zoneEntity[]>([]);

  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company } = userProfile;

  const getAllTeam = async (
    page: number,
    take: number,
    search?: string | null,
    status?: string | null | undefined,
  ) => {
    try {
      const payload: payloadTeam = {
        page: page,
        take: take,
        sortField: "updatedAt",
        sortDirection: "DESC",
        search: search || "",
        company: company,
        status: status == "ALL" ? undefined : status,
      };
      const res = await teamDatasource.getAllTeam(payload);
      setTeamList({ count: res.count || 0, data: res.data });
      // return searchTeam(res, search, status);
    } catch (error) {
      console.error("Error fetching team data:", error);
      throw error; // or handle the error as needed
    }
  };

  // function searchTeam(
  //   team: teamEntity[],
  //   search?: string | null,
  //   filterIsActive?: string | boolean | null | undefined,
  // ): teamEntity[] {
  //   return zones.filter((zone) => {
  //     const matchesZoneName =
  //     search === "" ||
  //     search === undefined ||
  //     search === null ||
  //       zone.zoneName.toLowerCase().includes(search.toLowerCase());
  //     const matchesIsActive =
  //       filterIsActive === "all" ||
  //       filterIsActive === undefined ||
  //       filterIsActive === null ||
  //       zone.isActive === filterIsActive;
  //     return matchesZoneName && matchesIsActive;
  //   });
  // }

  useEffect(() => {
    getAllTeam(page, pageSize, search, status);
  }, [search, status, page]);

  // useEffect(() => {
  //   const fetchZones = async () => {
  //     try {
  //       await getAllTeam(page, pageSize, search, status);
  //     } catch (error) {
  //       console.error("Error fetching zones:", error);
  //       throw error;
  //     }
  //   };

  //   fetchZones();
  // }, [search, status, page]);

  const ActionBtn = ({ onClick, icon }: any) => {
    return (
      <Col span={6}>
        <div className='btn btn-icon btn-light btn-hover-primary btn-sm' onClick={onClick}>
          <span
            className='svg-icon svg-icon-primary svg-icon-2x'
            style={{ color: color["primary"] }}
          >
            {icon}
          </span>
        </div>
      </Col>
    );
  };

  const columns: any = [
    {
      title: "ชื่อเขต",
      dataIndex: "shopNo",
      key: "shopNo",
      width: "50%",
      render: (value: any, row: teamEntity, index: number) => {
        return {
          children: (
            <>
              <Text level={5}>{row.teamName}</Text>
            </>
          ),
        };
      },
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              <Tag color={value == "ACTIVE" ? color.success : color.placeholder}>
                {value === "ACTIVE" ? "เปิดใช้งาน" : "ปิดใช้งาน"}
              </Tag>
            </Row>
          ),
        };
      },
    },
    {
      title: "อัปเดตโดย",
      dataIndex: "shopName",
      key: "shopName",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Text level={5} fontSize={14}>
                {dateFormatter(row.updatedAt, false)}
              </Text>

              <br />
              <Text level={5} color='Text3'>
                {row.updatedBy}
              </Text>
            </>
          ),
        };
      },
    },

    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      hidden: !isEdit,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify={"start"} gutter={8}>
              <Col span={6}>
                <Button
                  onClick={() =>
                    navigate(`/generalSettings/createTeamSetting/${row.teamId}`, { state: { row } })
                  }
                  typeButton='secondary'
                  icon={<img src={icon.iconEdit} style={{ width: "18px", height: "18px" }} />}
                />
              </Col>
            </Row>
          ),
        };
      },
    },
  ].filter((x) => !x.hidden);

  const PageTitle = (
    <>
      <Row gutter={16}>
        <Col span={20}>
          <Text level={3} fontWeight={700}>
            รายการทีม
          </Text>
        </Col>
        {isCreate && (
          <Col className='gutter-row' span={4}>
            <Button
              title='+ เพิ่มทีม'
              onClick={() => navigate("/generalSettings/createTeamSetting/create")}
            />
          </Col>
        )}
      </Row>
      <br />
      <Row gutter={16}>
        <Col span={18}>
          <Input
            allowClear
            placeholder='ค้นหาชื่อทีม'
            prefix={<SearchOutlined style={{ color: "grey" }} />}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />
        </Col>

        <Col span={6}>
          <Select
            allowClear
            defaultValue={"ALL"}
            placeholder='สถานะ'
            data={[
              { key: "all", value: "ALL", label: "สถานะทั้งหมด" },
              { key: "active", value: "ACTIVE", label: "เปิดใช้งาน" },
              { key: "inactive", value: "INACTIVE", label: "ปิดใช้งาน" },
            ]}
            style={{ width: "100%" }}
            onChange={(e) => {
              setPage(1);
              setStatus(e);
            }}
          />
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <CardContainer>
        {PageTitle}
        <br />
        <Table
          columns={columns}
          dataSource={teamList?.data || []}
          pagination={{
            position: ["bottomCenter"],
            pageSize,
            current: page,
            total: teamList.count,
            onChange: (p) => setPage(p),
            showSizeChanger: false,
          }}
        />
      </CardContainer>
    </>
  );
};
